import gql from 'graphql-tag';

const COUNTS_QUERY = gql`
  query counts(
    $filters: [Filter!]
    $savedSearchIds: [Int!]
    $privateLaneIds: [String!]
  ) {
    counts(
      filters: $filters
      savedSearchIds: $savedSearchIds
      privateLaneIds: $privateLaneIds
    ) {
      activeCount
      activeCountUnfiltered
      allCount
      allCountUnfiltered
      allInventoryCount
      allInventoryCountUnfiltered
      comingSoonCount
      comingSoonCountUnfiltered
      makeOfferCount
      makeOfferCountUnfiltered
      privateLaneCount
      privateLaneCountUnfiltered
      watchListCount
    }
  }
`;

export default COUNTS_QUERY;
